import { BaseGetProvider } from "@tendercuts/http";
import { Injectable } from "@angular/core";
import { Inventory } from "@tendercuts/models";
import { HttpClient } from "@angular/common/http";
import { EndPoint } from "@endpoint";

@Injectable({
  providedIn: "root",
})
export class FetchInventoryService extends BaseGetProvider<Inventory> {
  constructor(public http: HttpClient, public endpointService: EndPoint) {
    super(http);
  }

  get isCachable(): boolean {
    return false;
  }

  get isAuthenticatedEndpoint(): boolean {
    return false;
  }

  get authProtocol(): any {
    return null;
  }

  get model(): typeof Inventory {
    return Inventory;
  }

  get endpoint(): string {
    return this.endpointService.inventory;
  }
}
